export function extendsConstructor(ChildCtor, ParentCtor, allowIdentical = true) {
  if (!ChildCtor || !ParentCtor) return false;
  if (allowIdentical && ChildCtor === ParentCtor) return true;
  if (ChildCtor.prototype instanceof ParentCtor) return true;
  return false;
}